import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useState } from "react";
import UserTransaction from "./UserTransaction";
import UserMessage from "./UserMessage";
import { useLocation } from "react-router-dom";

const UserPage = () => {
    const [tab, setTab] = useState(1);
    const { state } = useLocation();

  return (
    <div style={{ paddingTop: "10px" }}>
      <Header />
      <div className="d-flex content-box">
        <Menu />
        <div className="w-100 me-lg-3 ms-lg-5">
          <div
            className="d-flex justify-content-end"
            style={{ marginLeft: "20px" }}
          >
            <div className="admin-expert-tab-btn">
              <button
                className={`btn  ${tab === 1 && "active"}`}
                onClick={() => {
                  setTab(1);
                }}
                style={{ fontSize: "small" }}
                type="button"
              >
                ویرایش کاربر
              </button>
            </div>
            <div className="admin-expert-tab-btn">
              <button
                className={`btn  ${tab === 2 && "active"}`}
                onClick={() => {
                  setTab(2);
                }}
                type="button"
              >
                ارسال پیام
              </button>
            </div>
          </div>
          <div className="admin-expert-content-box px-2 py-3">
            <div
              className="px-3 d-flex align-items-center"
              style={{
                height: "50px",
                borderRadius: "30px",
                backgroundColor: "rgba(217, 217, 217, 0.20",
              }}
            >
              <strong>{state.name}</strong>
            </div>
           {
            tab === 1 ? <UserTransaction/> : 
            tab === 2 ? <UserMessage/> :""
           }
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPage;